module.exports = new __parcel__URL__("chat-emojis-darkmode.6cddbb3f.svg").toString();